import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import favorite from "modules/favorite";
import dataFormatter from "utils/dataFormatter";

class FavoriteLibraries extends Component {
  constructor(props) {
    super(props);
    props.getFavorite();
  }

  render() {
    return (
      <div className="margin-normal">
        <div className="information-table margin-large">
          <div className="col-narrow">
            <div className="underline-title underline-title--no_underline">
              {" "}
              Библиотеки{" "}
            </div>
          </div>
          <div className="col-wide">
            Среди библиотек Москвы есть девять с большими залами и фондами.
            Каждая из них в чем-то уникальна. Вы можете узнать об их услугах,
            пространстве и событиях на официальных сайтах.
          </div>
        </div>
        <div>
          {dataFormatter(this.props.favorite).map((row, index) => {
            return (
              <div key={index} className="imagae-table">
                {row.map((col, index) => {
                  return (
                    <Link
                      key={index}
                      className={`imagae-table-cell imagae-table-cell--${
                        row.length
                      }`}
                      to={{ pathname: `/libraries/${col.url}` }}
                    >
                      <img
                        className="image"
                        src={`${process.env.REACT_APP_IMG_SERVER}/img/${col.image_id}/mobile`}
                        alt=""
                      />
                      <div dangerouslySetInnerHTML={{ __html: col.title }} />
                      <div className="icon-arrow" />
                    </Link>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  favorite: state.favorite.data
});

const mapDispatchToProps = dispatch => ({
  getFavorite: bindActionCreators(favorite.actions.getFavorite, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FavoriteLibraries);



// WEBPACK FOOTER //
// ./src/components/FavoriteLibraries/FavoriteLibraries.js